import * as React from 'react';
import OrderDetails from '../../components/Orders/OrdersList/OrderDetails/OrderDetails';
var Order = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u0414\u0435\u0442\u0430\u0439\u043B\u0438 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    React.createElement(OrderDetails, null))))));
};
export default Order;



//////////////////
// WEBPACK FOOTER
// ./src/views/Orders/Order.tsx
// module id = 386
// module chunks = 0